// NOTE: HashをFormDataに変換
// ex1)
// {
//   level1: {
//     level1String: 'hoge1',    => formData.append('level1[level1String]', 'hoge1')
//     level1Array:  [1, 2],     => formData.append('level1[level1Array][]', 1)
//                               => formData.append('level1[level1Array][]', 2)
//     level2: {
//       level2String: 'hoge2',  => formData.append('level1[level2][level2String]', 'hoge2')
//       level2Array:  [1, 2],   => formData.append('level1[level2][level2String][]', 1)
//                               => formData.append('level1[level2][level2String][]', 2)
//     }
//   }
// }
// {
//
// ex2)
// {
//   level1A:  'hoge1',          => formData.append('level1A', 'hoge1')
//   level1B:  'hoge2',          => formData.append('level1B', 'hoge2')
//   level1C:  [1, 2],           => formData.append('level1C[]', 1)
//                               => formData.append('level1C[]', 1)
//   level1D:  {
//     level2D: 'hoge3'          => formData.append('level1D[level2D]', 'hoge3')
//   },
// }
class FormDataBuilder {
  static toFormData(params) {
    if (!params) return params;

    const formData = new FormData();
    this.buildFormData(formData, '', params)
    return formData;
  }

  static buildFormData(formData, appendKey, params) {
    for (let [key, value] of Object.entries(params)) {
      if (Array.isArray(params)) key = '';
      if (appendKey) key = `${appendKey}[${key}]`;

      if (value instanceof Object && !(value instanceof File)) {
        this.buildFormData(formData, key, value);
      } else {
        formData.append(key, value);
      }
    }
  }
}

module.exports = FormDataBuilder;



// WEBPACK FOOTER //
// ./src/libs/utils/form_data_builder.js